import {Col, Row} from "react-bootstrap";

import {useTranslation} from "../../../Utils/UseTranslation";
import {useEffect, useState} from "react";
import './../../../assets/css/ProductUse.css'
import GlucoseReadings from "../../Reader/FirstTimeSetup/HomeScreens/GlucoseReadings";

const InAfternoon = () => {
    const {t, i18n} = useTranslation()
    const lang = localStorage.getItem('lang');
    const [image, setImage] = useState([]);
    const [imageApp, setImageApp] = useState([]);
    const [behaviorIndex, setBehaviorIndex] = useState(0);
    const behavior = ['reader_72']
    useEffect(() => {
        setImage(`/translations/${lang}/ProductUse/treatmentGuide/reader_72.png`)
        setImageApp(`/translations/${lang}/ProductUse/treatmentGuide/app_72.png`)
    }, [lang])
    useEffect(() => {
        console.log(image)
    }, [image])

    return (

        <Row>
            <Col md={4} className={'text-start '}>
                <p className={'p-2'}>
                    <b>{t("whatYouSee")}: </b> {t("afternoon_text")}
                </p>
                <p className={'p-2 treatmentColoured'}>
                    <b>{t("whatMeans")}: </b> {t('afternoon_text_2')}

                </p>

            </Col>
            <Col md={8} className={'align-items-center justify-content-center d-inline-flex  px-5'}>
                <div className={'text-center'}>
                    <p className={'mx-0'}>
                        <b> {t('reader')}</b>
                    </p>
                    <div style={{width: '230px'}}>
                        <GlucoseReadings navigateToComponent={''} setFirstActivation={''}
                                         sensorIsActive={true} setSensorIsActive={''}
                                         firstActivation={false} behaviorIndex={behaviorIndex}
                                         behavior={behavior} isStatic={true}/></div>

                </div>


            </Col>



        </Row>

    )
}

export default InAfternoon